// TODO FIXME Has to be moved in reduc folder ?
import generatedLocation from './location.json'

export const location = generatedLocation
